// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"435c98a4","498":"652fd1d9","644":"e175aa35"}[chunkId] + ".chunk.js";
};